import React, { useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PlusOutlined, AppstoreOutlined } from '@ant-design/icons'
import QueryTable, { QueryTableRef } from 'components/common/queryTable/QueryTable'
import dayjs from 'dayjs'
import { Tag } from 'antd'
import Ret00cActionBar, {
  RET00C_ACTION_BAR_WRAPPER_CLASS_NAME,
  RET00C_ACTION_BAR_WRAPPER_STYLE,
} from './Ret00cActionBar'
import { useRet00cGroupFilter } from './useRet00cGroupFilter'

function List(): JSX.Element {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { selectedGroupId, setSelectedGroupId, openGroupModal } = useRet00cGroupFilter()
  const tableRef = useRef<QueryTableRef>(null)

  React.useEffect(() => {
    const v = searchParams.get('ret00cd_id')
    setSelectedGroupId(v ? Number(v) : undefined)
  }, [searchParams, setSelectedGroupId])

  const columns = [
    {
      title: '接口编码',
      dataIndex: 'code',
      key: 'code',
      sorter: true,
    },
    {
      title: '接口名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '接口分组',
      dataIndex: 'group_path_name',
      key: 'group_path_name',
      render: (groupPathName: string) => groupPathName || '-',
    },
    {
      title: '请求方式',
      dataIndex: 'http_method',
      key: 'http_method',
      render: (httpMethod: string) => httpMethod || '-',
    },
    {
      title: '接口路径',
      dataIndex: 'path',
      key: 'path',
      render: (path: string) => path || '-',
    },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (updated_at: string) => {
        return updated_at ? dayjs(updated_at).format('YYYY-MM-DD HH:mm:ss') : '-'
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const colorMap: Record<string, string> = {
          enabled: 'green',
          disabled: 'default',
          draft: 'orange',
        }
        const labelMap: Record<string, string> = {
          enabled: '启用',
          disabled: '停用',
          draft: '草稿',
        }
        const currentStatus = status || 'draft'

        return <Tag color={colorMap[currentStatus] || 'default'}>{labelMap[currentStatus] || currentStatus}</Tag>
      },
    },
  ]

  return (
    <div className="w-full min-w-0">
      <QueryTable
        ref={tableRef}
        remoteUrl="/console/ret00cs"
        extraParams={{ ret00cd_id: selectedGroupId }}
        columns={columns}
        filterBarPosition="right"
        filterBarWrapperClassName={RET00C_ACTION_BAR_WRAPPER_CLASS_NAME}
        filterBarWrapperStyle={RET00C_ACTION_BAR_WRAPPER_STYLE}
        antdTableProps={{
          bordered: true,
          rowKey: 'id',
          size: 'small',
        }}
        onRowClick={(record) => {
          navigate(`/ret00cs/${record.id}`)
        }}
        filterBarOptions={
          [
            {
              type: 'input',
              label: '关键字',
              name: 'keyword',
            },
          ]
        }
        filterBarMoreActions={
          <Ret00cActionBar
            className="mb-0 border-0 bg-transparent px-0 py-0 rounded-none"
            items={[
              {
                key: 'new',
                label: '新增',
                icon: <PlusOutlined />,
                onClick: () => {
                  navigate('/ret00cs/new')
                },
              },
              {
                key: 'group',
                label: '分组管理',
                icon: <AppstoreOutlined />,
                onClick: openGroupModal,
              },
            ]}
          />
        }
      />
    </div>
  )
}

export default List
